import React from 'react';
import { VscSearch } from 'react-icons/vsc';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { searchInput } from '../../../redux/slice/productslice';

const HeroSearch = () => {
    const dispatch = useDispatch()
    const searchText = useSelector((state) => state.cart.search)
    return (
        <>
            <div style={{ backgroundColor: "#fff8ec" }} className='md:py-16 mt-16 mb-1'>

                <div className="container m-auto flex flex-col space-y-1">
                    <div className="text-2xl font-semibold text-center hidden md:block">Ghore Bazar is your online supershop in Dhaka City</div>
                    <div className="text-center hidden md:block">Express delivery at your door step within 90 minutes</div>
                    <div className="form-control md:mx-28 sm:mx-12 mx-8">

                        <div className="relative bg-white shadow-sm rounded-full mt-5">
                            <input type="text" placeholder="Search For Your Products like rice, pottato" value={searchText} onChange={(e) => dispatch(searchInput(e.target.value))} className="w-full pr-16 input input-ghost" />
                            <button className="absolute top-0 right-0 rounded-full btn outline-0 border-0 bg-gradient-to-t hover:from-red-800 hover:to-red-400 from-red-600 to-red-300"><VscSearch /></button>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};

export default HeroSearch;